module.exports = __webpack_public_path__ + "static/img/vouchers5010.65eb1cf1.png";